/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { MockNexus } from "../MockNexus";

export class MockNexus__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _governorAddr: string,
    _savingsManager: string,
    _interestValidator: string,
    overrides?: Overrides
  ): Promise<MockNexus> {
    return super.deploy(
      _governorAddr,
      _savingsManager,
      _interestValidator,
      overrides || {}
    ) as Promise<MockNexus>;
  }
  getDeployTransaction(
    _governorAddr: string,
    _savingsManager: string,
    _interestValidator: string,
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(
      _governorAddr,
      _savingsManager,
      _interestValidator,
      overrides || {}
    );
  }
  attach(address: string): MockNexus {
    return super.attach(address) as MockNexus;
  }
  connect(signer: Signer): MockNexus__factory {
    return super.connect(signer) as MockNexus__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MockNexus {
    return new Contract(address, _abi, signerOrProvider) as MockNexus;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_governorAddr",
        type: "address",
      },
      {
        internalType: "address",
        name: "_savingsManager",
        type: "address",
      },
      {
        internalType: "address",
        name: "_interestValidator",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_key",
        type: "bytes32",
      },
    ],
    name: "getModule",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "governor",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "initialized",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "modules",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_interestValidator",
        type: "address",
      },
    ],
    name: "setInterestValidator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_savingsManager",
        type: "address",
      },
    ],
    name: "setSavingsManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x608060405234801561001057600080fd5b506040516103cd3803806103cd83398101604081905261002f91610102565b6000805460016020527f7b0bc268032209bf552b77f1d94ce34772f16bd5cfdccd99a27dc662c0e5518580546001600160a01b039586166001600160a01b0319918216179091557fc10a28f028c7f7282a03c90608e38a4a646e136e614e4b07d119280c5f7f839f83527fe7dc3cb2a4a095f2b1c5598977b63617b54108bb02ae83a00c045074ac65fa4e80549486169482169490941790935560ff60a01b1993909416919093161716600160a01b179055610144565b80516001600160a01b03811681146100fd57600080fd5b919050565b600080600060608486031215610116578283fd5b61011f846100e6565b925061012d602085016100e6565b915061013b604085016100e6565b90509250925092565b61027a806101536000396000f3fe608060405234801561001057600080fd5b50600436106100625760003560e01c80630c340a2414610067578063158ef93e146100975780637358e854146100ba57806385acd64114610134578063998468ec1461015d578063b0b6cc1a146101d5575b600080fd5b60005461007a906001600160a01b031681565b6040516001600160a01b0390911681526020015b60405180910390f35b6100aa600054600160a01b900460ff1690565b604051901515815260200161008e565b6101326100c83660046101fe565b7f12fe936c77a1e196473c4314f3bed8eeac1d757b319abb85bdda70df35511bf160005260016020527f7b0bc268032209bf552b77f1d94ce34772f16bd5cfdccd99a27dc662c0e5518580546001600160a01b0319166001600160a01b0392909216919091179055565b005b61007a61014236600461022c565b6000908152600160205260409020546001600160a01b031690565b61013261016b3660046101fe565b7fc10a28f028c7f7282a03c90608e38a4a646e136e614e4b07d119280c5f7f839f60005260016020527fe7dc3cb2a4a095f2b1c5598977b63617b54108bb02ae83a00c045074ac65fa4e80546001600160a01b0319166001600160a01b0392909216919091179055565b61007a6101e336600461022c565b6001602052600090815260409020546001600160a01b031681565b60006020828403121561020f578081fd5b81356001600160a01b0381168114610225578182fd5b9392505050565b60006020828403121561023d578081fd5b503591905056fea2646970667358221220f8c5e003ca9d07da3a6640460bc6cf078894f40f1d2f00cf2aebcd47ff09e05164736f6c63430008020033";
